import React, { useState, useEffect, useMemo } from "react";
import Header from "../layouts/Header";
import Footer from "../layouts/Footer";
import { Link, useNavigate } from "react-router-dom";
import { 
  Card, 
  Table, 
  Row, 
  Col, 
  Form, 
  InputGroup, 
  Button, 
  Pagination, 
 
  Badge, 
  Modal, 
  Alert, 
  Spinner, 
  Toast, 
  ToastContainer,
  ProgressBar,
  ListGroup
} from "react-bootstrap";
import {
  Bell,
 
  CheckCircle,
  ExclamationCircle,
  InfoCircle,
  XCircle,
  Clock,
  Calendar,
  Person,

  Receipt,
  Tag,
  Check,
  X,
  Trash,
  Eye,
  Check2Circle,
 
  Search,
  
  ChevronDown,
  ChevronUp,
  
  Envelope,

  Printer,
  Share,
 
} from "react-bootstrap-icons";

// Données de démo pour les notifications
const demoNotifications = [
  {
    id: 1,
    titre: "Paiement validé",
    message: "Le paiement COL-2023-001 a été validé avec succès",
    type: "success",
    date: "2023-10-15T14:30:00Z",
    lu: false,
    icone: <CheckCircle />,
    categorie: "paiement",
    details: {
      reference: "COL-2023-001",
      montant: "1.250.000 XOF",
      contribuable: "Entreprise ABC SARL",
      agent: "Jean Dupont"
    }
  },
  {
    id: 2,
    titre: "Paiement en retard",
    message: "Le paiement COL-2023-003 est en retard de 10 jours",
    type: "warning",
    date: "2023-10-15T10:15:00Z",
    lu: false,
    icone: <ExclamationCircle />,
    categorie: "retard",
    details: {
      reference: "COL-2023-003",
      montant: "320.000 XOF",
      contribuable: "SARL Excellence",
      joursRetard: 10
    }
  },
  {
    id: 3,
    titre: "Nouveau contribuable",
    message: "Un nouveau contribuable a été enregistré",
    type: "info",
    date: "2023-10-14T16:45:00Z",
    lu: true,
    icone: <Person />,
    categorie: "contribuable",
    details: {
      nom: "M. Alioune Ndiaye",
      nif: "NIF88888888",
      type: "Particulier"
    }
  },
  {
    id: 4,
    titre: "Taxe mise à jour",
    message: "La taxe TF001 a été modifiée",
    type: "info",
    date: "2023-10-14T11:20:00Z",
    lu: true,
    icone: <Tag />,
    categorie: "taxe",
    details: {
      code: "TF001",
      nom: "Taxe Foncière Urbaine",
      changement: "Taux mis à jour de 15% à 15.5%"
    }
  },
  {
    id: 5,
    titre: "Échéance approchant",
    message: "L'échéance de 3 paiements approche dans 5 jours",
    type: "warning",
    date: "2023-10-13T09:30:00Z",
    lu: true,
    icone: <Clock />,
    categorie: "echeance",
    details: {
      nombrePaiements: 3,
      joursRestants: 5,
      totalMontant: "2.450.000 XOF"
    }
  },
  {
    id: 6,
    titre: "Collecte annulée",
    message: "La collecte COL-2023-007 a été annulée",
    type: "danger",
    date: "2023-10-12T15:10:00Z",
    lu: true,
    icone: <XCircle />,
    categorie: "annulation",
    details: {
      reference: "COL-2023-007",
      motif: "Erreur de saisie",
      agent: "Pierre Martin"
    }
  },
  {
    id: 7,
    titre: "Objectif mensuel atteint",
    message: "Objectif de collecte mensuel atteint à 105%",
    type: "success",
    date: "2023-10-11T17:00:00Z",
    lu: true,
    icone: <CheckCircle />,
    categorie: "performance",
    details: {
      objectif: "50.000.000 XOF",
      collecte: "52.500.000 XOF",
      pourcentage: 105
    }
  },
  {
    id: 8,
    titre: "Maintenance système",
    message: "Maintenance prévue ce week-end",
    type: "info",
    date: "2023-10-10T08:45:00Z",
    lu: true,
    icone: <InfoCircle />,
    categorie: "systeme",
    details: {
      date: "14-15 Octobre 2023",
      heure: "22h00 - 06h00",
      impact: "Système temporairement indisponible"
    }
  },
  {
    id: 9,
    titre: "Nouvelle taxe créée",
    message: "La taxe TPD002 a été créée avec succès",
    type: "success",
    date: "2023-10-09T14:20:00Z",
    lu: true,
    icone: <Tag />,
    categorie: "taxe",
    details: {
      code: "TPD002",
      nom: "Taxe Publicité Supplémentaire",
      taux: "12%"
    }
  },
  {
    id: 10,
    titre: "Rapport mensuel disponible",
    message: "Le rapport mensuel de septembre est disponible",
    type: "info",
    date: "2023-10-08T10:00:00Z",
    lu: true,
    icone: <Receipt />,
    categorie: "rapport",
    details: {
      periode: "Septembre 2023",
      collecteTotale: "185.450.000 XOF",
      tauxRecouvrement: "78%"
    }
  }
];

export default function NotificationsPage() {
  const navigate = useNavigate();
  
  // États principaux
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterText, setFilterText] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [sortField, setSortField] = useState('date');
  const [sortDirection, setSortDirection] = useState('desc');
  const [selectedNotifications, setSelectedNotifications] = useState([]);
  
  // États pour les filtres
  const [selectedFilter, setSelectedFilter] = useState('all');
  const [selectedCategory, setSelectedCategory] = useState('all');
  
  // États pour les modals
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [notificationDetails, setNotificationDetails] = useState(null);
  const [showClearModal, setShowClearModal] = useState(false);
  const [showBulkDeleteModal, setShowBulkDeleteModal] = useState(false);
  
  // États pour les notifications Toast
  const [toastNotifications, setToastNotifications] = useState([]);
  const [alertMessage, setAlertMessage] = useState({ show: false, message: '', type: 'info' });

  // Catégories
  const categories = [
    { value: "all", label: "Toutes catégories" },
    { value: "paiement", label: "Paiements", color: "success" },
    { value: "retard", label: "Retards", color: "warning" },
    { value: "contribuable", label: "Contribuables", color: "info" },
    { value: "taxe", label: "Taxes", color: "primary" },
    { value: "echeance", label: "Échéances", color: "warning" },
    { value: "annulation", label: "Annulations", color: "danger" },
    { value: "performance", label: "Performance", color: "success" },
    { value: "systeme", label: "Système", color: "secondary" },
    { value: "rapport", label: "Rapports", color: "info" }
  ];

  // Filtres de statut
  const filters = [
    { value: "all", label: "Tous les statuts" },
    { value: "unread", label: "Non lues" },
    { value: "read", label: "Lues" }
  ];

  // Initialiser les données
  useEffect(() => {
    setTimeout(() => {
      setNotifications(demoNotifications);
      setLoading(false);
    }, 800);
  }, []);

  // Fonctions pour les notifications Toast
  const showToast = (message, type = 'info', duration = 5000) => {
    const id = Date.now();
    const toast = {
      id,
      message,
      type,
      show: true
    };
    
    setToastNotifications(prev => [toast, ...prev]);
    
    setTimeout(() => {
      hideToast(id);
    }, duration);
  };

  const hideToast = (id) => {
    setToastNotifications(prev => prev.filter(toast => toast.id !== id));
  };

  const showAlert = (message, type = 'warning', duration = 5000) => {
    setAlertMessage({ show: true, message, type });
    
    if (duration > 0) {
      setTimeout(() => {
        hideAlert();
      }, duration);
    }
  };

  const hideAlert = () => {
    setAlertMessage({ show: false, message: '', type: 'info' });
  };

  // Filtrer et trier les notifications
  const filteredAndSortedItems = useMemo(() => {
    let filtered = notifications.filter(notif => {
      const searchTerm = filterText.toLowerCase();
      
      // Filtre par recherche
      const matchesSearch = 
        notif.titre.toLowerCase().includes(searchTerm) ||
        notif.message.toLowerCase().includes(searchTerm);
      
      // Filtre par état lu/non lu
      if (selectedFilter !== 'all') {
        if (selectedFilter === 'unread' && notif.lu) return false;
        if (selectedFilter === 'read' && !notif.lu) return false;
      }
      
      // Filtre par catégorie
      if (selectedCategory !== 'all' && notif.categorie !== selectedCategory) {
        return false;
      }
      
      return matchesSearch;
    });

    // Tri
    filtered.sort((a, b) => {
      let aValue = a[sortField] || '';
      let bValue = b[sortField] || '';
      
      if (sortField === 'date') {
        aValue = new Date(aValue).getTime();
        bValue = new Date(bValue).getTime();
      }
      
      if (typeof aValue === 'string' && typeof bValue === 'string') {
        aValue = aValue.toLowerCase();
        bValue = bValue.toLowerCase();
      }
      
      if (sortDirection === 'asc') {
        return aValue > bValue ? 1 : -1;
      } else {
        return aValue < bValue ? 1 : -1;
      }
    });

    return filtered;
  }, [notifications, filterText, selectedFilter, selectedCategory, sortField, sortDirection]);

  // Statistiques
  const stats = useMemo(() => {
    const total = notifications.length;
    const nonLues = notifications.filter(n => !n.lu).length;
    const aujourdhui = notifications.filter(n => {
      const today = new Date();
      const notifDate = new Date(n.date);
      return notifDate.toDateString() === today.toDateString();
    }).length;
    const cetteSemaine = notifications.filter(n => {
      const now = new Date();
      const notifDate = new Date(n.date);
      const diffTime = Math.abs(now - notifDate);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      return diffDays <= 7;
    }).length;
    
    return { total, nonLues, aujourdhui, cetteSemaine };
  }, [notifications]);

  // Pagination
  const totalPages = Math.ceil(filteredAndSortedItems.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentItems = filteredAndSortedItems.slice(startIndex, startIndex + itemsPerPage);

  // Fonctions de tri
  const handleSort = (field) => {
    if (sortField === field) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortDirection('asc');
    }
  };

  // Gestion des sélections
  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedNotifications(currentItems.map(notif => notif.id));
    } else {
      setSelectedNotifications([]);
    }
  };

  const handleSelectNotification = (notificationId) => {
    setSelectedNotifications(prev => 
      prev.includes(notificationId) 
        ? prev.filter(id => id !== notificationId)
        : [...prev, notificationId]
    );
  };

  const isAllSelected = currentItems.length > 0 && selectedNotifications.length === currentItems.length;
  const isSomeSelected = selectedNotifications.length > 0 && selectedNotifications.length < currentItems.length;

  // Marquer comme lu
  const markAsRead = (id) => {
    setNotifications(prev => 
      prev.map(notif => 
        notif.id === id ? { ...notif, lu: true } : notif
      )
    );
    
    if (id === 'all') {
      showToast('Toutes les notifications ont été marquées comme lues', 'success');
    } else {
      const notif = notifications.find(n => n.id === id);
      if (notif) {
        showToast(`Notification "${notif.titre}" marquée comme lue`, 'success');
      }
    }
  };

  // Marquer toutes comme lues
  const markAllAsRead = () => {
    setNotifications(prev => 
      prev.map(notif => ({ ...notif, lu: true }))
    );
    showToast('Toutes les notifications ont été marquées comme lues', 'success');
  };

  // Supprimer une notification
  const deleteNotification = (id) => {
    if (id === 'all') {
      setNotifications([]);
      showToast('Toutes les notifications ont été supprimées', 'success');
    } else {
      setNotifications(prev => prev.filter(notif => notif.id !== id));
      setSelectedNotifications(prev => prev.filter(selId => selId !== id));
      showToast('Notification supprimée', 'success');
    }
  };

  // Suppression multiple
  const handleBulkDelete = () => {
    if (selectedNotifications.length === 0) {
      showAlert("Veuillez sélectionner au moins une notification", 'warning');
      return;
    }
    setShowBulkDeleteModal(true);
  };

  const handleConfirmBulkDelete = () => {
    setNotifications(prev => prev.filter(notif => !selectedNotifications.includes(notif.id)));
    setSelectedNotifications([]);
    setShowBulkDeleteModal(false);
    showToast(`${selectedNotifications.length} notification(s) supprimée(s) avec succès`, 'success');
  };

  // Voir les détails
  const viewDetails = (notification) => {
    setNotificationDetails(notification);
    // Marquer comme lu quand on voit les détails
    if (!notification.lu) {
      markAsRead(notification.id);
    }
    setShowDetailsModal(true);
  };

  // Effacer toutes les notifications
  const clearAllNotifications = () => {
    setShowClearModal(true);
  };

  const confirmClearAll = () => {
    setNotifications([]);
    setSelectedNotifications([]);
    setShowClearModal(false);
    showToast('Toutes les notifications ont été supprimées', 'success');
  };

  // Formatage des dates
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffTime = Math.abs(now - date);
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    const diffHours = Math.floor(diffTime / (1000 * 60 * 60));
    const diffMinutes = Math.floor(diffTime / (1000 * 60));
    
    if (diffMinutes < 1) return "À l'instant";
    if (diffMinutes < 60) return `Il y a ${diffMinutes} min`;
    if (diffHours < 24) return `Il y a ${diffHours} h`;
    if (diffDays === 1) return "Hier";
    if (diffDays < 7) return `Il y a ${diffDays} jours`;
    
    return date.toLocaleDateString('fr-FR', {
      day: 'numeric',
      month: 'short',
      year: 'numeric'
    });
  };

  const formatDateTime = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString('fr-FR', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  // Obtenir la couleur du type
  const getTypeColor = (type) => {
    const colors = {
      success: 'success',
      warning: 'warning',
      danger: 'danger',
      info: 'info'
    };
    return colors[type] || 'secondary';
  };

  // Obtenir l'icône du type
  const getTypeIcon = (type) => {
    const icons = {
      success: <CheckCircle />,
      warning: <ExclamationCircle />,
      danger: <XCircle />,
      info: <InfoCircle />
    };
    return icons[type] || <InfoCircle />;
  };

  // Obtenir le badge de catégorie
  const getCategoryBadge = (categorie) => {
    const category = categories.find(c => c.value === categorie);
    if (!category) return null;
    
    return (
      <Badge bg={`${category.color}-subtle`} text={category.color} className="fw-medium">
        {category.label}
      </Badge>
    );
  };

  // Obtenir le badge de statut lu/non lu
  const getReadStatusBadge = (lu) => {
    if (lu) {
      return <Badge bg="success-subtle" text="success">Lue</Badge>;
    } else {
      return <Badge bg="danger">Non lue</Badge>;
    }
  };

  // Composant pour l'en-tête triable
  const SortableHeader = ({ field, children }) => (
    <th 
      style={{ cursor: 'pointer', userSelect: 'none' }}
      onClick={() => handleSort(field)}
      className="position-relative"
    >
      {children}
      {sortField === field && (
        <span className="ms-1">
          {sortDirection === 'asc' ? <ChevronUp size={12} /> : <ChevronDown size={12} />}
        </span>
      )}
    </th>
  );

  return (
    <React.Fragment>
      <Header />
      
      <div className="main main-app p-3 p-lg-4">
        {/* Container pour les notifications Toast */}
        <ToastContainer 
          position="top-end"
          className="p-3"
          style={{ zIndex: 9999 }}
        >
          {toastNotifications.map((toast) => (
            <Toast
              key={toast.id}
              show={toast.show}
              onClose={() => hideToast(toast.id)}
              delay={8000}
              autohide
              className={`bg-${toast.type === 'success' ? 'success' : 
                         toast.type === 'error' ? 'danger' :
                         toast.type === 'warning' ? 'warning' : 'info'} text-white`}
            >
              <Toast.Header className={`bg-${toast.type === 'success' ? 'success' : 
                         toast.type === 'error' ? 'danger' :
                         toast.type === 'warning' ? 'warning' : 'info'} text-white`}>
                {toast.type === 'success' ? <CheckCircle className="me-2" /> :
                 toast.type === 'error' ? <XCircle className="me-2" /> :
                 toast.type === 'warning' ? <ExclamationCircle className="me-2" /> :
                 <CheckCircle className="me-2" />}
                <strong className="me-auto">
                  {toast.type === 'success' ? 'Succès' : 
                   toast.type === 'error' ? 'Erreur' :
                   toast.type === 'warning' ? 'Attention' : 'Information'}
                </strong>
                <small>{new Date().toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}</small>
              </Toast.Header>
              <Toast.Body className="text-white">
                {toast.message}
              </Toast.Body>
            </Toast>
          ))}
        </ToastContainer>

        {/* Alerte Bootstrap */}
        {alertMessage.show && (
          <div className="container-fluid mb-3">
            <Alert 
              variant={alertMessage.type} 
              dismissible 
              onClose={hideAlert}
              className="shadow-sm border-0"
            >
              <div className="d-flex align-items-center">
                {alertMessage.type === 'success' ? <CheckCircle className="me-2 fs-5" /> :
                 alertMessage.type === 'danger' ? <XCircle className="me-2 fs-5" /> :
                 alertMessage.type === 'warning' ? <ExclamationCircle className="me-2 fs-5" /> :
                 <CheckCircle className="me-2 fs-5" />}
                <span className="fw-medium">{alertMessage.message}</span>
              </div>
            </Alert>
          </div>
        )}

        <div className="container-fluid">
          <Row className="mb-4">
            <Col md={12}>
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <ol className="breadcrumb fs-sm mb-1">
                    <li className="breadcrumb-item"><Link to="/admin/dashboard">Tableau de bord</Link></li>
                    <li className="breadcrumb-item active" aria-current="page">Notifications</li>
                  </ol>
                  <h4 className="main-title mb-0">
                    <Bell className="me-2" />
                    Notifications
                  </h4>
                  <p className="text-muted mb-0">Gérez vos alertes et notifications</p>
                </div>

                <div className="d-flex gap-2">
                  {selectedNotifications.length > 0 && (
                    <>
                      <Button 
                        variant="outline-success" 
                        size="sm"
                        onClick={() => {
                          selectedNotifications.forEach(id => markAsRead(id));
                          setSelectedNotifications([]);
                        }}
                      >
                        <Check2Circle className="me-2" size={16} />
                        Marquer comme lues
                      </Button>
                      <Button 
                        variant="outline-danger" 
                        size="sm"
                        onClick={handleBulkDelete}
                      >
                        <Trash className="me-2" size={16} />
                        Supprimer ({selectedNotifications.length})
                      </Button>
                    </>
                  )}
                  
                  {/* <Button 
                    variant="outline-secondary" 
                    onClick={() => navigate(-1)}
                    className="d-flex align-items-center"
                  >
                    <ArrowLeft className="me-2" size={16} />
                    Retour
                  </Button> */}
                </div>
              </div>
            </Col>
          </Row>

          {/* Cartes de statistiques */}
          <Row className="g-3 mb-4">
            <Col md={6} lg={4}>
              <Card className="border-0 shadow-sm overflow-hidden stats-card">
                <div className="card-gradient bg-primary"></div>
                <Card.Body>
                  <div className="d-flex justify-content-between align-items-start">
                    <div>
                      <h6 className="text-uppercase text-muted mb-2">Total</h6>
                      <h2 className="mb-0">{stats.total}</h2>
                      <div className="mt-2">
                        <Badge bg="primary-subtle" text="primary" className="fw-medium">
                          <Bell className="me-1" size={12} />
                          Notifications
                        </Badge>
                      </div>
                    </div>
                    <div className="icon-container bg-primary-subtle">
                      <Bell className="text-primary" size={28} />
                    </div>
                  </div>
                  <div className="progress-wrapper mt-3">
                    <div className="d-flex justify-content-between mb-1">
                      <small className="text-muted">Non lues</small>
                      <small className="fw-medium">{stats.nonLues}</small>
                    </div>
                    <ProgressBar 
                      now={stats.total > 0 ? (stats.nonLues / stats.total) * 100 : 0} 
                      variant="primary"
                      className="stats-progress"
                    />
                  </div>
                </Card.Body>
              </Card>
            </Col>
            
            <Col md={6} lg={4}>
              <Card className="border-0 shadow-sm overflow-hidden stats-card">
                <div className="card-gradient bg-success"></div>
                <Card.Body>
                  <div className="d-flex justify-content-between align-items-start">
                    <div>
                      <h6 className="text-uppercase text-muted mb-2">Aujourd'hui</h6>
                      <h2 className="mb-0">{stats.aujourdhui}</h2>
                      <div className="mt-2">
                        <Badge bg="success-subtle" text="success" className="fw-medium">
                          <Calendar className="me-1" size={12} />
                          Ce jour
                        </Badge>
                      </div>
                    </div>
                    <div className="icon-container bg-success-subtle">
                      <Calendar className="text-success" size={28} />
                    </div>
                  </div>
                  <div className="progress-wrapper mt-3">
                    <div className="d-flex justify-content-between mb-1">
                      <small className="text-muted">Cette semaine</small>
                      <small className="fw-medium">{stats.cetteSemaine}</small>
                    </div>
                    <ProgressBar 
                      now={stats.total > 0 ? (stats.cetteSemaine / stats.total) * 100 : 0} 
                      variant="success"
                      className="stats-progress"
                    />
                  </div>
                </Card.Body>
              </Card>
            </Col>
            
            <Col md={6} lg={4}>
              <Card className="border-0 shadow-sm overflow-hidden stats-card">
                <div className="card-gradient bg-warning"></div>
                <Card.Body>
                  <div className="d-flex justify-content-between align-items-start">
                    <div>
                      <h6 className="text-uppercase text-muted mb-2">Alertes</h6>
                      <h2 className="mb-0">
                        {notifications.filter(n => n.type === 'warning' || n.type === 'danger').length}
                      </h2>
                      <div className="mt-2">
                        <Badge bg="warning-subtle" text="warning" className="fw-medium">
                          <ExclamationCircle className="me-1" size={12} />
                          Urgentes
                        </Badge>
                      </div>
                    </div>
                    <div className="icon-container bg-warning-subtle">
                      <ExclamationCircle className="text-warning" size={28} />
                    </div>
                  </div>
                  <div className="progress-wrapper mt-3">
                    <div className="d-flex justify-content-between mb-1">
                      <small className="text-muted">Succès</small>
                      <small className="fw-medium">
                        {notifications.filter(n => n.type === 'success').length}
                      </small>
                    </div>
                    <ProgressBar 
                      now={stats.total > 0 ? (notifications.filter(n => n.type === 'success').length / stats.total) * 100 : 0} 
                      variant="warning"
                      className="stats-progress"
                    />
                  </div>
                </Card.Body>
              </Card>
            </Col>
            
            {/* <Col md={6} lg={3}>
              <Card className="border-0 shadow-sm overflow-hidden stats-card">
                <div className="card-gradient bg-info"></div>
                <Card.Body>
                  <div className="d-flex justify-content-between align-items-start">
                    <div>
                      <h6 className="text-uppercase text-muted mb-2">Actions</h6>
                      <div className="d-grid gap-2 mt-2">
                        <Button 
                          variant="outline-primary" 
                          size="sm"
                          onClick={markAllAsRead}
                        >
                          <Check2Circle className="me-2" size={14} />
                          Tout marquer comme lu
                        </Button>
                        <Button 
                          variant="outline-danger" 
                          size="sm"
                          onClick={clearAllNotifications}
                        >
                          <Trash className="me-2" size={14} />
                          Tout effacer
                        </Button>
                      </div>
                    </div>
                    <div className="icon-container bg-info-subtle">
                      <BellFill className="text-info" size={28} />
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col> */}
          </Row>

          {/* Barre de recherche et filtres */}
          <Row className="mb-4">
            <Col md={12}>
              <Card className="border-0 shadow-sm">
                <Card.Body>
                  <Row className="g-3">
                    <Col md={3}>
                      <InputGroup>
                        <InputGroup.Text>
                          <Search />
                        </InputGroup.Text>
                        <Form.Control
                          type="text"
                          placeholder="Rechercher dans les notifications..."
                          value={filterText}
                          onChange={(e) => setFilterText(e.target.value)}
                        />
                      </InputGroup>
                    </Col>
                    <Col md={3}>
                      <Form.Select value={selectedFilter} onChange={(e) => setSelectedFilter(e.target.value)}>
                        {filters.map(filter => (
                          <option key={filter.value} value={filter.value}>{filter.label}</option>
                        ))}
                      </Form.Select>
                    </Col>
                    <Col md={3}>
                      <Form.Select value={selectedCategory} onChange={(e) => setSelectedCategory(e.target.value)}>
                        {categories.map(cat => (
                          <option key={cat.value} value={cat.value}>{cat.label}</option>
                        ))}
                      </Form.Select>
                    </Col>
                    <Col md={3}>
                      <div className="d-flex gap-2">
                        <Button
                          variant="outline-secondary"
                          onClick={() => {
                            setFilterText("");
                            setSelectedFilter("all");
                            setSelectedCategory("all");
                          }}
                          className="w-100"
                        >
                          <X className="me-2" />
                          Réinitialiser
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* Tableau principal */}
          <Row>
            <Col md={12}>
              <Card className="shadow-sm border-0">
                <Card.Header className="bg-primary text-white d-flex justify-content-between align-items-center py-3">
                  <div className="d-flex align-items-center">
                    <Bell className="me-2" />
                    <span className="fw-semibold">
                      Notifications ({filteredAndSortedItems.length})
                      {stats.nonLues > 0 && (
                        <Badge bg="danger" className="ms-2">
                          {stats.nonLues} non lues
                        </Badge>
                      )}
                    </span>
                  </div>
                  <div className="text-white-50 small">
                    {selectedNotifications.length > 0 && (
                      <span>{selectedNotifications.length} sélectionné(s)</span>
                    )}
                  </div>
                </Card.Header>
                
                <Card.Body className="p-0">
                  <div className="table-responsive">
                    <Table hover className="mb-0">
                      <thead className="bg-light">
                        <tr>
                          <th style={{ width: '40px' }}>
                            <div className="form-check">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                style={{
                                  borderRadius: '50%',
                                  width: '18px',
                                  height: '18px',
                                  cursor: 'pointer'
                                }}
                                checked={isAllSelected}
                                ref={input => {
                                  if (input) {
                                    input.indeterminate = isSomeSelected;
                                  }
                                }}
                                onChange={handleSelectAll}
                              />
                            </div>
                          </th>
                          <th>Type</th>
                          <SortableHeader field="titre">
                            Titre
                          </SortableHeader>
                          <th>Message</th>
                          <th>Catégorie</th>
                          <SortableHeader field="date">
                            Date
                          </SortableHeader>
                          <th>Statut</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {loading ? (
                          <tr>
                            <td colSpan="8" className="text-center py-5">
                              <div className="d-flex justify-content-center align-items-center">
                                <Spinner animation="border" variant="primary" className="me-3" />
                                <span className="text-muted">Chargement des notifications...</span>
                              </div>
                            </td>
                          </tr>
                        ) : currentItems.length > 0 ? (
                          currentItems.map((notification) => (
                            <tr 
                              key={notification.id} 
                              className={!notification.lu ? 'table-row-unread' : ''}
                              style={{
                                borderLeft: `4px solid var(--bs-${getTypeColor(notification.type)})`
                              }}
                            >
                              <td>
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  style={{
                                    borderRadius: '50%',
                                    width: '18px',
                                    height: '18px',
                                    cursor: 'pointer'
                                  }}
                                  checked={selectedNotifications.includes(notification.id)}
                                  onChange={() => handleSelectNotification(notification.id)}
                                />
                              </td>
                              <td>
                                <div className={`text-${getTypeColor(notification.type)}`}>
                                  {getTypeIcon(notification.type)}
                                </div>
                              </td>
                              <td>
                                <div>
                                  <strong className="d-block">{notification.titre}</strong>
                                  <small className="text-muted d-none d-md-block">
                                    {formatDateTime(notification.date)}
                                  </small>
                                </div>
                              </td>
                              <td>
                                <div className="text-truncate" style={{ maxWidth: '250px' }}>
                                  {notification.message}
                                </div>
                              </td>
                              <td>
                                {getCategoryBadge(notification.categorie)}
                              </td>
                              <td>
                                <div>
                                  <small className="d-block">{formatDate(notification.date)}</small>
                                  <small className="text-muted d-none d-md-block">
                                    <Clock size={12} className="me-1" />
                                    {formatDateTime(notification.date)}
                                  </small>
                                </div>
                              </td>
                              <td>
                                {getReadStatusBadge(notification.lu)}
                              </td>
                              <td>
                                <div className="d-flex gap-1">
                                  <Button
                                    size="sm"
                                    variant="outline-primary"
                                    title="Voir les détails"
                                    onClick={() => viewDetails(notification)}
                                    className="d-flex align-items-center justify-content-center"
                                    style={{ width: '32px', height: '32px' }}
                                  >
                                    <Eye size={14} />
                                  </Button>
                                  
                                  {!notification.lu && (
                                    <Button
                                      size="sm"
                                      variant="outline-success"
                                      title="Marquer comme lue"
                                      onClick={() => markAsRead(notification.id)}
                                      className="d-flex align-items-center justify-content-center"
                                      style={{ width: '32px', height: '32px' }}
                                    >
                                      <Check size={14} />
                                    </Button>
                                  )}
                                  
                                  <Button
                                    size="sm"
                                    variant="outline-danger"
                                    title="Supprimer"
                                    onClick={() => deleteNotification(notification.id)}
                                    className="d-flex align-items-center justify-content-center"
                                    style={{ width: '32px', height: '32px' }}
                                  >
                                    <Trash size={14} />
                                  </Button>
                                </div>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="8" className="text-center py-5">
                              <Bell size={48} className="text-muted" />
                              <p className="mt-3 text-muted">AUCUNE NOTIFICATION TROUVÉE.</p>
                              <p className="text-muted mb-3">
                                {filterText || selectedFilter !== 'all' || selectedCategory !== 'all'
                                  ? "Aucune notification ne correspond aux critères de recherche."
                                  : "Vous n'avez aucune notification pour le moment."}
                              </p>
                              {(filterText || selectedFilter !== 'all' || selectedCategory !== 'all') && (
                                <Button 
                                  variant="outline-primary" 
                                  size="sm"
                                  onClick={() => {
                                    setFilterText("");
                                    setSelectedFilter("all");
                                    setSelectedCategory("all");
                                  }}
                                >
                                  Réinitialiser les filtres
                                </Button>
                              )}
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </div>

                  {/* Pagination */}
                  {totalPages > 1 && (
                    <div className="p-3 border-top d-flex justify-content-between align-items-center">
                      <div className="text-muted small">
                        Affichage de {startIndex + 1} à {Math.min(startIndex + itemsPerPage, filteredAndSortedItems.length)} sur {filteredAndSortedItems.length} notifications
                        {selectedNotifications.length > 0 && (
                          <span className="ms-2 text-primary">• {selectedNotifications.length} sélectionné(s)</span>
                        )}
                      </div>
                      <Pagination className="mb-0">
                        <Pagination.Prev 
                          disabled={currentPage === 1}
                          onClick={() => setCurrentPage(currentPage - 1)}
                        />
                        {[...Array(totalPages)].map((_, index) => (
                          <Pagination.Item
                            key={index + 1}
                            active={index + 1 === currentPage}
                            onClick={() => setCurrentPage(index + 1)}
                          >
                            {index + 1}
                          </Pagination.Item>
                        ))}
                        <Pagination.Next 
                          disabled={currentPage === totalPages}
                          onClick={() => setCurrentPage(currentPage + 1)}
                        />
                      </Pagination>
                    </div>
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </div>

        {/* Modal de détails de notification */}
        <Modal 
          show={showDetailsModal} 
          onHide={() => setShowDetailsModal(false)} 
          size="lg"
          centered
          className="modal-details"
        >
          {notificationDetails && (
            <>
              <Modal.Header closeButton className="border-0 pb-2">
                <Modal.Title className="w-100">
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <div className="d-flex align-items-center">
                        <div className={`text-${getTypeColor(notificationDetails.type)} me-2`}>
                          {getTypeIcon(notificationDetails.type)}
                        </div>
                        <h4 className="mb-0">{notificationDetails.titre}</h4>
                        <Badge 
                          bg={getTypeColor(notificationDetails.type)} 
                          className="ms-2"
                        >
                          {categories.find(c => c.value === notificationDetails.categorie)?.label}
                        </Badge>
                      </div>
                      <div className="text-muted small mt-1">
                        <Clock className="me-1" />
                        {formatDateTime(notificationDetails.date)}
                      </div>
                    </div>
                    <div className="d-flex gap-2">
                      <Button variant="outline-secondary" size="sm">
                        <Printer className="me-1" />
                        Imprimer
                      </Button>
                      <Button variant="outline-primary" size="sm">
                        <Share className="me-1" />
                        Partager
                      </Button>
                    </div>
                  </div>
                </Modal.Title>
              </Modal.Header>
              
              <Modal.Body className="py-3">
                <Card className="border-0 shadow-sm mb-4">
                  <Card.Body>
                    <h5 className="mb-3 d-flex align-items-center">
                      <InfoCircle className="me-2 text-primary" />
                      Message
                    </h5>
                    <p className="mb-0 fs-5">{notificationDetails.message}</p>
                  </Card.Body>
                </Card>

                <Row>
                  <Col md={8}>
                    <Card className="border-0 shadow-sm">
                      <Card.Body>
                        <h5 className="mb-3 d-flex align-items-center">
                          <Bell className="me-2 text-primary" />
                          Détails
                        </h5>
                        
                        <ListGroup variant="flush">
                          {Object.entries(notificationDetails.details || {}).map(([key, value]) => (
                            <ListGroup.Item 
                              key={key} 
                              className="d-flex justify-content-between align-items-center border-0 px-0 py-2"
                            >
                              <span className="text-capitalize">{key.replace(/([A-Z])/g, ' $1').trim()}:</span>
                              <strong>{value}</strong>
                            </ListGroup.Item>
                          ))}
                        </ListGroup>
                      </Card.Body>
                    </Card>
                  </Col>
                  
                  <Col md={4}>
                    <Card className="border-0 shadow-sm">
                      <Card.Body>
                        <h5 className="mb-3 d-flex align-items-center">
                          <CheckCircle className="me-2 text-primary" />
                          Actions
                        </h5>
                        
                        <div className="d-grid gap-2">
                          {!notificationDetails.lu && (
                            <Button 
                              variant="success"
                              onClick={() => {
                                markAsRead(notificationDetails.id);
                                setShowDetailsModal(false);
                              }}
                              className="d-flex align-items-center justify-content-center"
                            >
                              <Check2Circle className="me-2" />
                              Marquer comme lu
                            </Button>
                          )}
                          
                          <Button 
                            variant="outline-primary"
                            className="d-flex align-items-center justify-content-center"
                          >
                            <Envelope className="me-2" />
                            Envoyer un rappel
                          </Button>
                          
                          <Button 
                            variant="outline-danger"
                            onClick={() => {
                              deleteNotification(notificationDetails.id);
                              setShowDetailsModal(false);
                            }}
                            className="d-flex align-items-center justify-content-center"
                          >
                            <Trash className="me-2" />
                            Supprimer
                          </Button>
                        </div>
                        
                        <div className="mt-4 pt-3 border-top">
                          <h6 className="mb-2">Statut</h6>
                          <div className="d-flex align-items-center">
                            <Badge 
                              bg={notificationDetails.lu ? "success-subtle" : "danger-subtle"} 
                              text={notificationDetails.lu ? "success" : "danger"}
                              className="py-2 px-3"
                            >
                              {notificationDetails.lu ? (
                                <>
                                  <CheckCircle className="me-2" />
                                  Notification lue
                                </>
                              ) : (
                                <>
                                  <Bell className="me-2" />
                                  Non lue
                                </>
                              )}
                            </Badge>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              </Modal.Body>
              
              <Modal.Footer className="border-0 pt-0">
                <Button variant="secondary" onClick={() => setShowDetailsModal(false)}>
                  Fermer
                </Button>
                <Button 
                  variant="primary"
                  onClick={() => {
                    // Action spécifique selon la catégorie
                    switch(notificationDetails.categorie) {
                      case 'paiement':
                        navigate(`/admin/paiements/${notificationDetails.details?.reference}`);
                        break;
                      case 'contribuable':
                        navigate(`/admin/contribuables/${notificationDetails.details?.nif}`);
                        break;
                      case 'taxe':
                        navigate(`/admin/taxes/${notificationDetails.details?.code}`);
                        break;
                      default:
                        setShowDetailsModal(false);
                    }
                  }}
                >
                  Voir les détails complets
                </Button>
              </Modal.Footer>
            </>
          )}
        </Modal>

        {/* Modal de confirmation pour effacer toutes les notifications */}
        <Modal 
          show={showClearModal} 
          onHide={() => setShowClearModal(false)} 
          centered
          size="md"
        >
          <Modal.Header closeButton className="bg-danger text-white">
            <Modal.Title className="d-flex align-items-center">
              <ExclamationCircle className="me-2" />
              Confirmation
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="py-4">
            <div className="text-center">
              <XCircle className="text-danger mb-3" size={48} />
              <h5 className="mb-3">Êtes-vous sûr de vouloir tout effacer ?</h5>
              <p className="text-muted">
                Cette action supprimera toutes les notifications ({notifications.length} élément(s)) 
                et ne peut pas être annulée.
              </p>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="outline-secondary" onClick={() => setShowClearModal(false)}>
              Annuler
            </Button>
            <Button variant="danger" onClick={confirmClearAll}>
              <Trash className="me-2" />
              Oui, tout effacer
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Modal de suppression multiple */}
        <Modal show={showBulkDeleteModal} onHide={() => setShowBulkDeleteModal(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title>
              <ExclamationCircle className="text-warning me-2" />
              Confirmer la suppression multiple
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="text-center">
              <Trash className="display-4 text-danger mb-3" size={48} />
              <h5>Supprimer {selectedNotifications.length} notification(s) ?</h5>
              <p className="text-muted mt-3">
                Vous êtes sur le point de supprimer définitivement {selectedNotifications.length} notification(s).
                <br />
                <strong>Cette action est irréversible.</strong>
              </p>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowBulkDeleteModal(false)}>
              <X className="me-2" />
              Annuler
            </Button>
            <Button variant="danger" onClick={handleConfirmBulkDelete}>
              <Trash className="me-2" />
              Supprimer {selectedNotifications.length} notification(s)
            </Button>
          </Modal.Footer>
        </Modal>

        <Footer />
      </div>

      <style>{`
        .main-app {
          background-color: #f8f9fa;
          min-height: calc(100vh - 60px);
        }
        
        .table-row-unread {
          background-color: rgba(0, 123, 255, 0.05) !important;
        }
        
        .table-row-unread:hover {
          background-color: rgba(0, 123, 255, 0.1) !important;
        }
        
        .icon-container {
          width: 50px;
          height: 50px;
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        
        .stats-progress {
          height: 6px;
          border-radius: 3px;
        }
        
        .modal-details .modal-header {
          background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
        }
        
        .breadcrumb {
          background: transparent;
          padding: 0;
          margin-bottom: 0.5rem;
        }
        
        .breadcrumb-item a {
          color: var(--bs-primary);
          text-decoration: none;
        }
        
        .breadcrumb-item.active {
          color: var(--bs-secondary);
        }
        
        .main-title {
          color: var(--bs-dark);
          font-weight: 600;
        }
        
        .stats-card {
          position: relative;
        }
        
        .card-gradient {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 4px;
        }
        
        @media (max-width: 768px) {
          .main-app {
            padding: 1rem !important;
          }
          
          .d-flex.justify-content-between {
            flex-direction: column;
            gap: 1rem;
          }
          
          .d-flex.gap-2 {
            flex-wrap: wrap;
          }
          
          .table-responsive {
            font-size: 0.875rem;
          }
        }
      `}</style>
    </React.Fragment>
  );
}